import script from "./sw-item-parts-password.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-password.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-password.vue?vue&type=style&index=0&id=75ba6924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ba6924"]])

export default __exports__